import { render } from "./InputEntityType.vue?vue&type=template&id=545bab6f"
import script from "./InputEntityType.vue?vue&type=script&lang=js"
export * from "./InputEntityType.vue?vue&type=script&lang=js"
script.render = render

export default script